/**
 * Util function used to match the error code with the list of expected error codes against a form field and
 * return the key whose value matches with the error code
 * @param {number} errorCode - Error code to be matched with the form field
 */
const matchErrorCodesToFields = (errorCode, errorCodeList) => {
  let field;
  Object.entries(errorCodeList).forEach(([key, value]) => {
    if (value.indexOf(errorCode) === 1) {
      field = key;
    }
  });
  return field;
};

export default matchErrorCodesToFields;
